import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../../client/components/ui/dialog";
import { Button } from "../../client/components/ui/button";
import useTranslation from "../../client/hooks/useTranslation";

export interface ResetLayoutDialogProps {
  open: boolean;
  onOpenChange: (b: boolean) => void;
  onConfirm: () => void;
}

export default function ResetLayoutDialog({ open, onOpenChange, onConfirm }: ResetLayoutDialogProps) {
  const t = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t.dashboard.resetLayoutConfirmTitle}</DialogTitle>
          <DialogDescription>{t.dashboard.resetLayoutConfirm}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>{t.common.cancel}</Button>
          <Button variant="destructive" onClick={() => { onConfirm(); onOpenChange(false); }}>{t.dashboard.resetLayout}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
